import styles from './styles.module.sass';
import { Params } from '@ui/params';
import { formatBagId } from '@lib/bag-formatting';
import { ModalDialog } from '@ui/modal-dialog';
import { useStore } from '@lib/state-engine';
import {
  $agriculture,
  $agricultureById,
  $agricultureModalIdEnable,
  $agricultureIsLoading,
} from '@@/agriculture/store/agriculture.store';
import { useEffect, useId, useRef, useState } from 'react';
import { useImmer } from 'use-immer';
import { FILL_BAG_DEFAULT_INPUTS } from '@features/fill-bag/constants';
import {
  $isFillingWarehouseBag,
  $warehouseId,
  fillWarehouseBag,
  useBag,
} from '@entities/warehouse/store';
import { onChangeByValuesFn } from '@@/common/ts';
import { setByValues } from '@@/common/utils/set-by-values.util';
import { UiButton } from '@@/ui/components/ui-button';
import classNames from 'classnames';
import { ButtonMain } from '@/modules/common/components/button';
import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { Col, Input, InputNumber, Modal, Row, notification } from 'antd';
import { SortPicker } from '@/modules/common/components/add-offer-modal/components/sort-picker';
import { SelectUniversal } from '@/modules/common/components/select-universal';
import { InputSignWrap } from '@/modules/common/components/input-sign-wrap';
import {
  wheatClasses,
  wheatSorts,
  wheatTypes,
} from '@/modules/common/constants/wheat-types.constatnt';
import {
  indicateWheatType,
  spreadWheatType,
} from '@/modules/common/helpers/wheat-type.helper';
import { BagsService } from '../../services/bags.service';
import { DiContainer } from '@/modules/di/di-container';
import { onSubmit } from '../../functions/on-submit.function';

import { Actions } from './components/actions-wheat';
import { InputWithSignWheelControl } from '@/modules/common/components/input-with-sign-wheel';
import { selectSleeve } from '@/widgets/storage-viewer/model';
import { warehouseModel } from '@/entities/warehouse';
import { handleClick } from '@/modules/helpers/handler-click/index.helper';
import { IBag } from '../../ts';
import { processNumberInput } from '@/modules/helpers/processNumberInput/processNumberInput';
const bagsService = DiContainer.get(BagsService);

export function FillBagModal({
  id,
  // title,
  onClose,
}: // agricultureIsLoading = true,
{
  id: string;
  // title: string;
  onClose: () => void;
  // actions: JSX.Element;
  // agricultureIsLoading: boolean;
}) {
  // CLICK OUTSIDE CALENDAR
  const elemRef = useRef<any>(null);
  const handleClickOutside = (event: any) => {
    if (elemRef.current && !elemRef.current.contains(event.target)) {
      setShowDatePicker(false);
    }
  };

  // STATES
  const [cultureId, setCultureId] = useState(-1);
  const [indicatedClass, setIndicatedClass] = useState(-1);
  const [sort, setSort] = useState('');
  const [type, setType] = useState('');
  const [error, setError] = useState<Record<string, string>>({});
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [customNumber, setCustomNumber] = useState(false);
  const fillWarehouseBagLocal = fillWarehouseBag;
  const formId = useId();
  const agricultureById = useStore($agricultureById);
  const [, edit] = useStore($agricultureModalIdEnable);
  const isLoading = useStore($isFillingWarehouseBag);
  const warehouseId = useStore($warehouseId);
  const agriculture = useStore($agriculture);
  const agricultureIsLoading = useStore($agricultureIsLoading);
  const selectedWarehouse = useStore(warehouseModel.$warehouseInfo);
  const bag = useBag(id);
  const [selectedCulture, setSelectedCulture] = useState<number | null>(
    bag.agricultureId || null,
  );
  const warehouseTypeSleeve = warehouseModel.WAREHOUSE_TYPES.sleeve;

  const title = !selectedCulture ? 'Выберите культуру' : 'Информация о хранилище';

  const customNamesBags = selectedWarehouse?.bags
    .filter((obj) => obj.customName != null)
    .map((obj) => obj.customName);

  const startInputs = {
    ...FILL_BAG_DEFAULT_INPUTS,
    weight: bag?.weight ? bag.weight.toString() : FILL_BAG_DEFAULT_INPUTS.weight,
    custom_name: bag?.customName
      ? Number(bag.customName)
      : FILL_BAG_DEFAULT_INPUTS.custom_name,
    description: bag?.description
      ? bag.description.toString()
      : FILL_BAG_DEFAULT_INPUTS.description,
  };

  if (bag?.values?.length && bag?.agricultureId) {
    let parameters = agricultureById[bag.agricultureId].parameters;
    if (parameters) {
      startInputs.parameters = bag.values.reduce(
        (acc: { [key: number]: string }, val) => {
          if (val.value === null) return acc;
          let id = parameters.find((p) => p.name == val.name)?.id;
          if (!id) return acc;
          acc[id] = val.value;
          return acc;
        },
        {},
      );
    }
  }

  const [inputs, setInputs] = useImmer(startInputs);
  const onSelectCulture = (id: number) => {
    setSelectedCulture(id);
    setInputs((draft) => {
      draft.parameters = agricultureById[id].parameters.reduce((acc, parameter) => {
        if (parameter.id === 7)
          return {
            ...acc,
            [parameter.id]: '23',
          };
        return {
          ...acc,
          [parameter.id]: String(parameter.options.min ?? 0),
        };
      }, {} as Record<number, string>);
    });
  };

  const onChangeInput: onChangeByValuesFn = (values) => {
    setInputs((draft) => void setByValues(draft, values));
  };

  // EFFECTS

  useEffect(() => {
    if (!!type && !!sort) {
      const wheatType = indicateWheatType(sort, type);
      onChangeInput({ wheatType });
      onChangeInput({ [`parameters.${37}`]: wheatType });
    }
  }, [type, sort]);

  useEffect(() => {
    const wheatType = inputs.parameters[37];
    if (wheatType) {
      const res = spreadWheatType(+wheatType);
      res && setSort(res?.sort);
      res && setType(res?.type);
    }
    // if (!inputs.parameters[7]) {
    //   // if temperature was not set
    //   onChangeInput({ [`parameters.${7}`]: '23' });
    // }
  }, [inputs]);

  useEffect(() => {
    if (
      inputs.wheatType &&
      inputs.parameters[5] &&
      inputs.parameters[1] &&
      inputs.parameters[3] &&
      inputs.parameters[4] &&
      inputs.parameters[6] &&
      inputs.parameters[7] &&
      inputs.parameters[2]
    ) {
      (async () => {
        const res: any = await bagsService.getWheatClass({
          wheat_type: String(inputs.wheatType),
          protein: inputs.parameters[5],
          gluten: inputs.parameters[1],
          idk: inputs.parameters[3],
          hfn: inputs.parameters[4],
          density: inputs.parameters[6],
          temperature: inputs.parameters[7],
          moisture: inputs.parameters[2],
          weed: '1',
        });
        setIndicatedClass(res.wheat_class);
      })();
    }
  }, [
    inputs.wheatType,
    inputs.parameters[5],
    inputs.parameters[1],
    inputs.parameters[3],
    inputs.parameters[4],
    inputs.parameters[6],
    inputs.parameters[7],
    inputs.parameters[2],
  ]);

  // useEffect(() => {
  //   if (inputs.fillDate && !isDateNotLaterThanToday(inputs.fillDate)) {
  //     // console.log(!isDateNotLaterThanToday(inputs.fillDate));
  //     onChangeInput({ fillDate: new Date() });
  //     console.log(inputs.fillDate)
  //   }
  // }, [inputs.fillDate])

  useEffect(() => {
    setIndicatedClass(Number(inputs.parameters[38]));

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (indicatedClass && indicatedClass > 0) {
      onChangeInput({ [`parameters.${38}`]: indicatedClass });
    }
  }, [indicatedClass]);

  const setWheatClassFormOrigin = async (
    id: number,
    currentId: number,
    wheat_type?: number,
  ) => {
    if (!wheat_type)
      return notification.warning({ message: 'Необходимо указать сорт и тип пшеницы' });
    const res: any = await bagsService.getClassParams(currentId, wheat_type);
    return Modal.confirm({
      title: 'Подтвердите действие',
      content:
        'Данное действие переустановит параметры зерна, на соответсвующие для выбранного класа, Вы уверены что хотите продолжить?',
      okText: 'да',
      cancelText: 'нет',
      onOk: () => {
        const parameters = [];
        parameters[5] = res.protein;
        parameters[1] = res.gluten;
        parameters[3] = res.idk;
        parameters[4] = res.hfn;
        parameters[6] = res.density;
        parameters[7] = res.temperature ? res.temperature : 23;
        parameters[2] = res.moisture;
        parameters[37] = wheat_type;
        parameters[38] = res.wheat_class;

        setInputs({ ...inputs, parameters });
        setIndicatedClass(currentId);
      },
    });
  };
  // const test = async () => {
  //   const res = await bagsService.getClassParams(3,5);
  //   console.log(res)
  // }
  // console.log(test())

  const actions = !selectedCulture ? (
    <>
      <ButtonMain
        active={cultureId > -1}
        onClick={() => onSelectCulture(cultureId)}
        label="далее"
        px={100}
        py={10}
      />
    </>
  ) : (
    <Actions
      inputs={inputs}
      isLoading={isLoading}
      onSubmit={(e) => {
        if (Object.values(error).length) {
          Object.values(error).forEach((e) => {
            notification.warning({
              message: e,
            });
          });
          return;
        }
        if (customNumber) {
          return;
        }
        onSubmit(e as any, {
          selectedCulture: Number(selectedCulture),
          warehouseId,
          inputs,
          fillWarehouseBagLocal,
          id,
          agricultureById,
        });

        selectSleeve(id);
      }}
      elemRef={elemRef}
      showDatePicker={showDatePicker}
      setShowDatePicker={setShowDatePicker}
      edit={edit}
      formId={formId}
      onChangeInput={onChangeInput}
    />
  );
  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    e.preventDefault();
    const input: EventTarget & HTMLInputElement = e.currentTarget;
    const currentValue = parseFloat(input.value) || 0;
    const delta = Math.sign(e.deltaY) * -1;
    // Проверяем новое значение до его установки
    const newValue = Math.max(0, currentValue + delta);

    const searchByNumbers = customNamesBags?.includes(newValue.toString()) ?? false;
    setCustomNumber(searchByNumbers);

    input.value = newValue.toString();
    onChangeInput({ custom_name: newValue });
  };
  const descriptionMaxLength = 30;
  return (
    <ModalDialog
      className={styles.modal}
      title={title}
      onClose={onClose}
      actions={actions}
      loading={agricultureIsLoading}
      contentClassName={styles.contentWrap}
      actionsClassName={!selectedCulture && styles.actionsBar}
    >
      <div>
        {!selectedCulture && (
          <>
            <div className={styles.agriculture}>
              {agriculture.map((agriculture) => (
                <button
                  key={agriculture.id}
                  className={classNames(
                    styles.cultureButton,
                    cultureId === agriculture.id && styles.activeButton,
                  )}
                  onClick={
                    () => setCultureId(agriculture.id)
                    //() => onSelectCulture(agriculture.id)
                  }
                >
                  <div className={styles.label}>{agriculture.name}</div>
                  <img src={`${agriculture.img}`} alt={agriculture.name} />
                </button>
              ))}
            </div>
          </>
        )}

        {selectedCulture && (
          <div className={styles.content}>
            <Params
              className={styles.cultureParameters}
              list={[
                {
                  label: 'культура:',
                  value: agricultureById[selectedCulture].name.toLowerCase(),
                },
                { label: 'ID хранилища:', value: formatBagId(id) },
              ]}
            />
            <div className={styles.explanation}>
              <div className={styles.user_parameters}>
                <span className={styles.label}>
                  {selectedWarehouse?.type === warehouseTypeSleeve
                    ? '№ рукава :'
                    : '№ объема :'}
                </span>
                <InputNumber
                  value={
                    inputs.custom_name === ''
                      ? inputs.custom_name
                      : Number(inputs.custom_name)
                  }
                  min={0}
                  max={9999}
                  maxLength={4}
                  onWheel={handleWheel}
                  onClick={handleClick}
                  onChange={(val: number | null) => {
                    const searchByNumbers =
                      customNamesBags?.includes(val?.toString()) ?? false;
                    setCustomNumber(searchByNumbers);
                    onChangeInput({
                      custom_name: val,
                    });
                  }}
                ></InputNumber>
              </div>
              {customNumber && (
                <span className={styles.warning}>
                  {selectedWarehouse?.type === warehouseTypeSleeve
                    ? 'такой номер уже присвоен рукаву на этом складе'
                    : 'такой номер уже присвоен объему на этом складе'}
                </span>
              )}
              <div className={styles.user_parameters}>
                <span className={styles.label}>описание :</span>
                <Input
                  placeholder={
                    selectedWarehouse?.type === warehouseTypeSleeve
                      ? 'Введите описание данного рукава'
                      : 'Введите описание данного объема'
                  }
                  showCount
                  maxLength={descriptionMaxLength}
                  onClick={handleClick}
                  value={inputs.description}
                  style={{ width: '300px' }}
                  onChange={(e) => {
                    const newValue =
                      e.target.value.length > descriptionMaxLength
                        ? e.target.value.slice(0, descriptionMaxLength)
                        : e.target.value;
                    onChangeInput({
                      description: newValue,
                    });
                  }}
                ></Input>
              </div>
            </div>

            {selectedCulture === 1 && (
              <>
                <Row
                  gutter={8}
                  style={{
                    marginBottom: 16,
                  }}
                >
                  <Col span={12}>
                    <InputSignWrap label={'сорт пшеницы*'}>
                      <SelectUniversal
                        activeItem={wheatSorts.find((item) => item.value === sort)}
                        onChange={(value: string) => setSort(value)}
                        options={wheatSorts}
                        placeholder="сорт не выбран"
                      />
                    </InputSignWrap>
                  </Col>

                  <Col span={12}>
                    <InputSignWrap label={'тип пшеницы*'}>
                      <SelectUniversal
                        activeItem={wheatTypes.find((item) => item.value === type)}
                        onChange={(value: string) => setType(value)}
                        options={wheatTypes}
                        placeholder="тип не указан"
                      />
                    </InputSignWrap>
                  </Col>
                </Row>

                <Row gutter={8} style={{ marginBottom: 16 }}>
                  <SortPicker
                    options={wheatClasses}
                    selectedId={indicatedClass}
                    onClick={(id) =>
                      setWheatClassFormOrigin(
                        indicatedClass,
                        Number(id),
                        inputs.wheatType,
                      )
                    }
                  />
                </Row>
              </>
            )}

            <Row gutter={16}>
              {agricultureById[selectedCulture].parameters.map((item) => {
                if (item.name === 'Класс' || item.name === 'Тип') return;
                const mandatoryParameters = (name: string): string => {
                  const mandatoryFields = [
                    'Влажность культуры',
                    'Температура',
                    'Натура',
                    'Клейковина',
                    'Число падения',
                    'Протеин',
                  ];

                  return mandatoryFields.includes(name)
                    ? item.name.toLowerCase() + '*'
                    : name === 'ИДК'
                    ? item.name + '*'
                    : item.name.toLowerCase();
                };
                return (
                  <Col span={6} style={{ marginTop: 24 }} className={styles.paramCol}>
                    <InputWithSignWheelControl
                      value={inputs.parameters[item.id]}
                      postfix={item.name === 'Протеин' ? '%' : item.units}
                      label={mandatoryParameters(item.name)}
                      onChange={(e) => {
                        const val = processNumberInput(e.target.value); // Фильтрация ввода
                        onChangeInput({ [`parameters.${item.id}`]: val }); // Просто передаём значение
                      }}
                      setValue={
                        (val) => onChangeInput({ [`parameters.${item.id}`]: val }) // Устанавливаем значение
                      }
                      min={item.options.min ? Number(item.options.min) : 0}
                      max={item.options.max ? Number(item.options.max) : undefined}
                      float={item.id === 5 || item.id === 2}
                      step={item.id === 5 ? 0.1 : undefined}
                      //setError={setError}
                    />
                  </Col>
                );
              })}
              <Col span={6} style={{ marginTop: 24 }} className={styles.paramCol}>
                <InputWithSignWheelControl
                  value={inputs.weight}
                  onChange={(e) =>
                    onChangeInput({
                      weight: processNumberInput(e.target.value),
                    })
                  }
                  setValue={(val) => onChangeInput({ weight: val })}
                  postfix={'т'}
                  label={'вес*'}
                  float={true}
                  //setError={setError}
                />
              </Col>
            </Row>

            {agricultureById[selectedCulture].name === 'Пшеница' && (
              <Row
                gutter={8}
                style={{
                  marginTop: 16,
                  marginBottom: 16,
                  borderBottom: '2px solid #EEF2FD',
                  paddingBottom: 16,
                }}
              >
                <Col span={8}>
                  <InputWithSignWheelControl
                    prefix="≤"
                    placeholder=""
                    value={inputs.weed}
                    label="сорная примесь"
                    onChange={(e) => {
                      onChangeInput({
                        weed: processNumberInput(e.target.value),
                      });
                    }}
                    setValue={(val) => {
                      onChangeInput({
                        weed: processNumberInput(val.toString()),
                      });
                    }}
                    postfix=""
                    autogrow={true}
                    //setError={setError}
                  />
                </Col>
                <Col span={8}>
                  <InputWithSignWheelControl
                    prefix="≤"
                    placeholder=""
                    value={inputs.admixtureOtherCereals}
                    label="примесь других злаковых культур"
                    onChange={(e) => {
                      onChangeInput({
                        admixtureOtherCereals: processNumberInput(e.target.value),
                      });
                    }}
                    setValue={(val) => {
                      onChangeInput({
                        admixtureOtherCereals: processNumberInput(val.toLocaleString()),
                      });
                    }}
                    postfix=""
                    //setError={setError}
                  />
                </Col>
                <Col span={8}>
                  <InputWithSignWheelControl
                    prefix="≤"
                    placeholder=""
                    value={inputs.wheatDifferentType}
                    label="пшеница другого типа"
                    onChange={(e) => {
                      onChangeInput({
                        wheatDifferentType: processNumberInput(e.target.value),
                      });
                    }}
                    setValue={(val) => {
                      onChangeInput({
                        wheatDifferentType: processNumberInput(val.toLocaleString()),
                      });
                    }}
                    postfix=""
                    autogrow={true}
                    //setError={setError}
                  />
                </Col>
              </Row>
            )}
          </div>

          // <div className={styles.content}>
          //   <Params
          //     className={styles.cultureParameters}
          //     list={[
          //       {
          //         label: 'культура:',
          //         value: agricultureById[selectedCulture].name.toLowerCase(),
          //       },
          //       { label: 'ID хранилища:', value: formatBagId(id) },
          //     ]}
          //   />

          //   <form className={styles.form} id={formId} onSubmit={onSubmit}>
          //     {agricultureById[selectedCulture].parameters.map((parameter) => {
          //       return (
          //         <UiTextField
          //           key={parameter.id}
          //           label={`${parameter.name} (${parameter.units})`}
          //           type="number"
          //           step={parameter.id === 5 || parameter.id === 2 ? 0.1 : 1}
          //           value={inputs.parameters[parameter.id]}
          //           required
          //           min={parameter.options.min ?? 0}
          //           max={parameter.options.max}
          //           onChange={({ value }) =>
          //             onChangeInput({ [`parameters.${parameter.id}`]: value })
          //           }
          //         />
          //       );
          //     })}

          //     <UiTextField
          //       label="Вес (т)"
          //       type="number"
          //       value={inputs.weight}
          //       required
          //       min={1}
          //       onChange={({ value }) => onChangeInput({ weight: value })}
          //     />
          //     <DatePicker
          //       dropdownClassName={styles.pickerDropdown}
          //       label="Дата заполнения"
          //       required
          //       value={inputs.fillDate}
          //       onChange={({ value }) => onChangeInput({ fillDate: value })}
          //     />
          //   </form>
          // </div>
        )}
        <span className={styles.label_explanation}>* обязательные параметры</span>
      </div>
    </ModalDialog>
  );
}
